import {Injectable} from '@angular/core';
import {NewsEntitiesEffects} from '../../../../store/effects/news-entities.effects';
import {NewsActions} from './news.actions';


@Injectable()
export class NewsEffects {

  constructor(
    private _newsEntitiesEffects: NewsEntitiesEffects,
  ) {
  }

  readonly readNews$ = this._newsEntitiesEffects.readNews$(
    NewsActions.readNews,
    NewsActions.readNewsSuccess,
    NewsActions.readNewsFailure,
  );

}
